import SeatSvg from "shared/Seat/SeatSvg";
import {SEAT_STATUS, SEAT_STATUS_ORDER} from "./seatStatus";

const SeatsBadges: React.FC = () => {
  return (
    <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-neutral-600 dark:text-neutral-300">
      {SEAT_STATUS_ORDER.map((status) => (
        <li key={status} className="flex items-center gap-1.5">
          <span className={`w-5 h-5 ${SEAT_STATUS[status].seat}`}>
            <SeatSvg backgroundColor="currentColor" />
          </span>
          {SEAT_STATUS[status].text}
        </li>
      ))}
    </ul>
  );
};

export default SeatsBadges;
